import gql from 'graphql-tag';

export default gql`
    mutation AddAssetLoadNotes($input: AddAssetLoadNotesInput) {
        addAssetLoadNotes(input: $input) {
            errors
            loadNotesId
        }
    }
`;
